export default __webpack_public_path__ + "static/media/chat9.d2ecf497.png";